<template>
<div>
    <div class="row">
      <div class="col-12">
        <h2>Edit Playlist</h2>
        <router-link :to="{ name: 'PlaylistsIndex' }" class="btn btn-sm btn-light">
          <i class="fa fa-arrow-left fa-fw" aria-hidden="true"></i>Playlists Index
        </router-link>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-9">
        <form>
          <div class="form-row">
              <div class="col-2">
                <label for="txtName" class="col-form-label">Playlist Name</label>
              </div>
              <div class="col-6">
                <input type="text" class="form-control" id="txtName" v-model="playlist.name">
              </div>
              <div class="col-4">
                <button type="button" class="btn btn-hub-primary" @click="addEditPlaylist(playlist)">Save</button>
              </div>
          </div>
          <hr>
          <div class="form-row">
            <div class="col-2">
              <label for="ddlSound" class="col-form-label">Sound</label>
            </div>
            <div class="col-6">
              <SoundDropDownAndPreview tag="playlist" v-bind:showLabel="false" v-model="selected_sound"></SoundDropDownAndPreview>
            </div>
            <div class="col-4">
              <button type="button" class="btn btn-hub-primary" @click="addSound"><i class="fa fa-plus" aria-hidden="true"></i> Add to Playlist</button>
            </div>
          </div>
          <br>
          <table class="table table-striped">
            <thead class="bg-hub-primary text-white">
              <tr>
                <th>Order</th>
                <th>Sound</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="playlist_item in playlist.playlist_items" :key="playlist_item.playlist_item_id">
                <td>{{ playlist_item.order }}</td>
                <td>{{ playlist_item.sound.filename }}</td>
                <td>
                  <div class="col middle-btn-col">
                    <a class="btn btn-sm btn-block btn-light" @click="reorderPlaylistItem(playlist_item.playlist_item_id, 'up')">
                      <i class="fa fa-arrow-up fa-fw" aria-hidden="true"></i>
                    </a>
                    <a class="btn btn-sm btn-block btn-light" @click="reorderPlaylistItem(playlist_item.playlist_item_id, 'down')">
                      <i class="fa fa-arrow-down fa-fw" aria-hidden="true"></i>
                    </a>
                  </div>
                </td>
                <td>
                    <a class="btn btn-sm btn-light" @click="deletePlaylistItem(playlist_item)">
                      <i class="fa fa-trash fa-fw" aria-hidden="true"></i>
                    </a>
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SoundDropDownAndPreview from '../../../components/SoundDropDownAndPreview'

export default {
  props: [
    'playlist_id'
  ],
  data: function () {
    return {
      selected_sound: ''
    }
  },
  components: { SoundDropDownAndPreview },
  computed: {
    ...mapGetters({
      playlist: 'singlePlaylist'
    })
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getPlaylist', this.playlist_id)
  },
  methods: {
    ...mapActions([
      'addEditPlaylist',
      'deletePlaylistItem'
    ]),
    addSound () {
      if (this.selected_sound !== 0) {
        this.$store.dispatch('addPlaylistItem',
          {
            playlist_id: this.playlist_id,
            sound_id: this.selected_sound.value,
            order: 0
          })
      } else {
        alert('Please select a sound.')
      }
    },
    reorderPlaylistItem (playlistItemId, direction) {
      this.$store.dispatch('reorderPlaylistItem', {
        playlist_item_id: playlistItemId,
        direction: direction
      })
    }
  }
}
</script>

<style scoped>

</style>
